import { IReferralTier } from './types';

// Tier rows must be keyed by a stable client-side identity, not by array index.
// With an index key, removing a tier lets the shifted-in tier reuse the deleted
// tier's subtree — `CampaignRules` is memoised and its `fieldPath` prop is
// unchanged (`tiers[0].rules` before and after), so it bails out of re-render
// and keeps a stale closure over the deleted tier's rules, writing them onto the
// survivor. Keying by `_id` makes React match the survivor's own instance, whose
// `fieldPath` then legitimately changes and busts the memo.
let tierUid = 0;

// Deterministic (test-friendly) counter — never Date.now()/Math.random().
export const nextTierRowId = (): string => `t-new-${++tierUid}`;

export const serverTierRowId = (id: number | string): string => `t-${id}`;

export const tierRowKey = (tier: Pick<IReferralTier, '_id'> | undefined, index: number): string =>
  tier?._id ?? `tier-index-${index}`;
